let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9l59e")).then(() => parcelRequire('9pMX2'));